/* Sezhi Organics — theme interactions
   Vanilla JS, no dependencies. Progressive enhancement only:
   every feature degrades gracefully if JS is disabled. */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.getElementById('sz-primary-nav');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---- Horizontal carousels (products / reviews) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-scroll]');
    if (!btn) return;
    var target = document.querySelector(btn.getAttribute('data-scroll-target'));
    if (!target) return;
    var dir = btn.getAttribute('data-scroll') === 'left' ? -1 : 1;
    target.scrollBy({ left: dir * Math.min(340, target.clientWidth * 0.8), behavior: 'smooth' });
  });

  /* ---- Product detail: quantity stepper + thumbnail swap ---- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var wrap = q.closest('.sz-qty');
      var input = wrap && wrap.querySelector('input');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        v += q.getAttribute('data-qty') === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
      }
      return;
    }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-main-image]');
      var src = thumb.getAttribute('data-thumb');
      if (main && src) main.setAttribute('src', src);
    }
  });

  /* ---- Collection: price range live label + auto-submit filters ---- */
  var priceRange = document.querySelector('[data-price-range]');
  if (priceRange) {
    var out = document.querySelector('[data-price-out]');
    priceRange.addEventListener('input', function () {
      if (out) out.textContent = out.getAttribute('data-prefix') + priceRange.value;
    });
  }
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var form = el.closest('form');
      if (form) form.submit();
    });
  });

  /* ---- Newsletter / contact inline note (non-Shopify demo forms) ---- */
  document.querySelectorAll('[data-demo-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var note = form.querySelector('[data-demo-note]');
      if (note) note.hidden = false;
      form.reset();
    });
  });
})();
